export const NAME = 'users';


/** WEBPACK FOOTER **
 ** ./src/modules/users/constants.js
 **/